module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('NavMenu', {
    on: {
      "blur": _vm.getBlur
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'blur': _vm.isBlur
    }
  }, [_c('router-view'), _vm._v(" "), _c('Foot'), _vm._v(" "), _c('TipDialog')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6488fe68"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/website.vue
// module id = 696
// module chunks = 17